export function initSliderDate($) {
  $('.slider-date--slider').not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    speed: 250,
    adaptiveHeight: true,
    nextArrow: $('.slider-date--arrows .next'),
    prevArrow: $('.slider-date--arrows .prev'),
  });
  
}
